import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../../global/commonStyle';

interface Props {
  isFreePlanButtonVisible?: boolean;
}

const PlanDiv = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-8);
  max-width: 186px;
  width: ${({ isFreePlanButtonVisible }) => (isFreePlanButtonVisible ? '100%' : '')};
  ${mobile_xl(css`
    max-width: calc(100% - 24px);
    display: block;
  `)} .fill-width {
    width: 100%;
  }
`;

const View = styled.div`
  cursor: pointer;
  padding: var(--space-6) var(--space-12);
  ${FlexBetween}
  gap: var(--space-10);
`;

const Text = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  line-height: 16px;
  padding: var(--space-6) var(--space-12);
  ${mobile_xl(css`
    margin-inline: var(--space-10);
  `)}
`;

const SubView = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
  p {
    ${Typography.body_md}
    color: var(--text-primary);
    margin: var(--space-0);
    line-height: 16px;
  }
  .fill-color {
    width: 16px;
    height: 16px;
    path {
      fill: var(--text-primary);
    }
  }
  .stroke-color {
    width: 16px;
    height: 16px;
    path {
      stroke: var(--text-primary);
    }
    rect {
      stroke: var(--text-primary);
    }
  }
`;

const ButtonDiv = styled.div`
  .dropdown-item {
    width: 100%;
  }
`;

const InviteButton = styled.div<Props>`
  ${FlexCenter}
  position: relative;
  padding: var(--space-4) var(--space-10) var(--space-5) var(--space-8);
  width: ${({ isFreePlanButtonVisible }) => (isFreePlanButtonVisible ? '' : '100%')};
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-8);
  gap: var(--space-4);
  cursor: pointer;
  &:hover {
    background-color: var(--background-secondary);
  }
  p {
    margin: var(--space-0);
    ${Typography.body_sm}
    color: var(--text-primary);
  }
  &:hover .icon-div {
    display: flex;
  }
  ${mobile_xl(css`
    display: none;
  `)}
`;

const IconDiv = styled.div`
  display: none;
  position: absolute;
  align-items: center;
  justify-content: center;
  padding: var(--space-3);
  top: 4px;
  right: 3px;
  border-radius: var(--border-radius-4);
  cursor: pointer;
  svg {
    fill: var(--text-secondary);
  }
  &:hover {
    background-color: var(--neutral-secondary);
    svg {
      fill: var(--text-primary);
    }
  }
`;

const TitleDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  svg {
    fill: var(--text-primary);
  }
  p {
    margin: var(--space-0);
    ${Typography.body_sm_medium}
  }
`;

const MainDiv = styled.div<Props>`
  display: flex;
  padding: var(--space-6) var(--space-12);
  gap: var(--space-8);
  flex-direction: ${({ isFreePlanButtonVisible }) => (isFreePlanButtonVisible ? 'column' : 'row-reverse')};
  justify-content: ${({ isFreePlanButtonVisible }) => (isFreePlanButtonVisible ? 'flex-start' : 'flex-end')};
`;

const IconFrame = styled.div`
  position: absolute;
  background: var(--background-secondary);
  width: 24px;
  height: 24px;
  top: -4px;
  left: -16px;
  border-radius: 8px;
  ${FlexCenter}
  cursor: pointer;
`;

export { PlanDiv, View, Text, SubView, ButtonDiv, InviteButton, IconDiv, TitleDiv, MainDiv, IconFrame };
